<template>
    <section style="padding: 16px">
        <el-card shadow="never" style="margin-bottom: 16px">
            <div slot="header">上传视频进行 AI 分析(转写 / 纪要 / 摘要)</div>
            <video-chunk-upload @uploaded="load"></video-chunk-upload>
        </el-card>

        <el-card shadow="never">
            <div slot="header">
                分析任务
                <el-button style="float: right; padding: 3px 0" type="text"
                           icon="el-icon-refresh" @click="load()">刷新
                </el-button>
            </div>
            <el-table :data="records" size="small">
                <el-table-column prop="id" label="#" width="60"></el-table-column>
                <el-table-column prop="title" label="标题" min-width="140" show-overflow-tooltip></el-table-column>
                <el-table-column prop="original_filename" label="视频文件" min-width="150"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="音频时长" width="90">
                    <template slot-scope="scope">{{ formatDuration(scope.row.duration) }}</template>
                </el-table-column>
                <el-table-column label="状态" width="150">
                    <template slot-scope="scope">
                        <el-tooltip :disabled="!scope.row.error_message"
                                    :content="scope.row.error_message || ''" placement="top">
                            <el-tag :type="statusInfo(scope.row.status).type" size="small">
                                <i v-if="statusInfo(scope.row.status).loading" class="el-icon-loading"></i>
                                {{ statusInfo(scope.row.status).text }}
                            </el-tag>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="创建时间" width="150"></el-table-column>
                <el-table-column label="操作" width="240">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status === 'done'" size="mini" type="primary"
                                   @click="view(scope.row)">查看结果
                        </el-button>
                        <el-button v-if="scope.row.status === 'failed'" size="mini" type="warning"
                                   @click="retry(scope.row)">重试
                        </el-button>
                        <el-button size="mini" type="danger" @click="remove(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 12px" layout="prev, pager, next, total" :total="total"
                           :page-size="page_size" :current-page.sync="page" @current-change="load()">
            </el-pagination>
        </el-card>

        <el-dialog :title="'分析结果 - ' + (current ? current.title : '')" :visible.sync="dialog"
                   width="80%" top="5vh">
            <el-tabs v-model="tab" @tab-click="loadResult">
                <el-tab-pane label="逐句转写" name="transcript"></el-tab-pane>
                <el-tab-pane label="智能纪要" name="minutes"></el-tab-pane>
                <el-tab-pane label="会议摘要" name="summary"></el-tab-pane>
            </el-tabs>
            <div style="text-align: right; margin-bottom: 8px">
                <el-button size="mini" icon="el-icon-download" :disabled="!raw && !segments"
                           @click="download">下载原始文件
                </el-button>
            </div>
            <div v-loading="result_loading" style="max-height: 60vh; overflow-y: auto">
                <template v-if="segments && segments.length">
                    <div v-for="(s, i) in segments" :key="i" style="margin-bottom: 10px">
                        <span style="color: #409EFF" v-if="s.speaker">[{{ s.speaker }}]</span>
                        <span style="color: #909399" v-if="s.time"> {{ s.time }}</span>
                        <div>{{ s.text }}</div>
                    </div>
                </template>
                <pre v-else-if="raw"
                     style="white-space: pre-wrap; word-break: break-all; font-family: inherit">{{ raw }}</pre>
                <div v-else-if="!result_loading" style="color: #909399">暂无内容</div>
            </div>
        </el-dialog>
    </section>
</template>

<script>
    import axios from 'axios';
    import api from '../config/api';
    import VideoChunkUpload from '../components/video-chunk-upload';

    const STATUS_MAP = {
        uploaded: {text: '排队等待处理', type: 'info', loading: true},
        converting: {text: '视频转码中', type: '', loading: true},
        converted: {text: '待上传腾讯', type: 'info', loading: true},
        uploading_tencent: {text: '上传腾讯中', type: '', loading: true},
        waiting_tencent: {text: '等待 AI 分析', type: '', loading: true},
        fetching: {text: '获取结果中', type: '', loading: true},
        done: {text: '分析完成', type: 'success', loading: false},
        failed: {text: '失败', type: 'danger', loading: false},
    };

    export default {
        name: 'admin-video-analysis',
        components: {VideoChunkUpload},
        data() {
            return {
                records: [],
                total: 0,
                page: 1,
                page_size: 10,
                timer: null,
                dialog: false,
                tab: 'transcript',
                current: null,
                raw: '',
                filename: '',
                segments: null,
                result_loading: false,
                raw_content: '',
            };
        },
        created() {
            this.load();
        },
        mounted() {
            // 静默轮询刷新任务状态(不走 $post,避免触发全局 loading)
            this.timer = setInterval(() => this.load(true), 10000);
        },
        beforeDestroy() {
            clearInterval(this.timer);
        },
        methods: {
            silentPost(url, data) {
                const token = this.$mixToken(this.$store.getters['user/token']);
                return axios.post(api.url + url, data, // JSON body,Laravel Request::input 可直接解析
                    {headers: {'user-token': token, 'Accept': 'application/json'}});
            },
            statusInfo(status) {
                return STATUS_MAP[status] || {text: status, type: 'info', loading: false};
            },
            formatDuration(sec) {
                if (!sec) return '-';
                const m = Math.floor(sec / 60), s = sec % 60;
                return m + '分' + (s < 10 ? '0' : '') + s + '秒';
            },
            load(silent) {
                if (silent) {
                    this.silentPost('/admin/video-analysis/list', {page: this.page}).then(res => {
                        if (res.data.success) {
                            this.records = res.data.data.records;
                            this.total = res.data.data.total;
                        }
                    }).catch(() => {});
                    return;
                }
                this.$api('Admin.VideoAnalysis.List', {page: this.page}, true).then(res => {
                    this.records = res.data.data.records;
                    this.total = res.data.data.total;
                    this.page_size = res.data.data.page_size;
                });
            },
            view(row) {
                this.current = row;
                this.tab = 'transcript';
                this.dialog = true;
                this.loadResult();
            },
            loadResult() {
                this.raw = '';
                this.segments = null;
                this.result_loading = true;
                const id = this.current.id, tab = this.tab; // 防快速切 tab 时迟到响应覆盖
                this.$api('Admin.VideoAnalysis.Result', {id: id, type: tab}, false)
                    .then(res => {
                        if (this.tab !== tab || !this.current || this.current.id !== id) return;
                        this.result_loading = false;
                        if (!res.data.success) {
                            this.raw = res.data.text;
                            return;
                        }
                        const data = res.data.data;
                        this.filename = data.filename;
                        if (data.format === 'json') {
                            const json = JSON.parse(data.content);
                            this.segments = this.normalize(json);
                            if (!this.segments) this.raw = JSON.stringify(json, null, 2);
                        } else {
                            this.raw = data.content;
                        }
                        this.raw_content = data.content;
                    })
                    .catch(() => {
                        if (this.tab === tab) this.result_loading = false;
                    });
            },
            // 转写 JSON 归一化。首选腾讯转写详情的真实结构(2026-08-04 实测):
            // {paragraphs:[{speaker:{user_name}, sentences:[{start_time(毫秒), words:[{text}]}]}]}
            normalize(node) {
                const root = node && (Array.isArray(node.paragraphs) ? node
                    : (node.minutes && Array.isArray(node.minutes.paragraphs) ? node.minutes : null));
                if (root) {
                    const list = [];
                    root.paragraphs.forEach(p => {
                        (p.sentences || []).forEach(s => {
                            const text = (s.words || []).map(w => w.text || '').join('');
                            if (!text) return;
                            list.push({
                                speaker: (p.speaker && p.speaker.user_name) || '',
                                time: this.formatMs(s.start_time != null ? s.start_time : p.start_time),
                                text: text,
                            });
                        });
                    });
                    if (list.length) return list;
                }
                // 兜底:递归寻找"逐句"数组(多数元素带 text/content/sentence 字段)
                const arr = this.findSegments(node);
                if (!arr) return null;
                const list = arr.map(it => ({
                    speaker: it.speaker_name || it.spk_name || it.username || it.nickname || '',
                    time: this.formatMs(it.start_time || it.begin_time || it.stime),
                    text: it.text || it.content || it.sentence || '',
                })).filter(s => s.text && typeof s.text === 'string');
                return list.length ? list : null;
            },
            findSegments(node) {
                if (Array.isArray(node)) {
                    const hits = node.filter(it => it && typeof it === 'object'
                        && (it.text || it.content || it.sentence));
                    if (node.length && hits.length >= node.length / 2) return node;
                }
                if (node && typeof node === 'object') {
                    for (const key of Object.keys(node)) {
                        const found = this.findSegments(node[key]);
                        if (found) return found;
                    }
                }
                return null;
            },
            formatMs(ms) {
                const n = parseInt(ms, 10);
                if (isNaN(n) || n < 0) return '';
                const total = Math.floor(n / 1000); // 腾讯转写时间戳为毫秒(实测确认)
                const m = Math.floor(total / 60), s = total % 60;
                return m + ':' + (s < 10 ? '0' : '') + s;
            },
            download() {
                const blob = new Blob([this.raw_content || this.raw],
                    {type: 'application/octet-stream'});
                const a = document.createElement('a');
                a.href = URL.createObjectURL(blob);
                a.download = this.filename || ('va' + this.current.id + '_' + this.tab);
                a.click();
                URL.revokeObjectURL(a.href);
            },
            retry(row) {
                this.$api('Admin.VideoAnalysis.Retry', {id: row.id}, true).then(() => {
                    this.$message.success('已重新加入处理队列');
                    this.load();
                });
            },
            remove(row) {
                this.$confirm('删除任务将同时删除其结果文件,确定?', '提示', {type: 'warning'})
                    .then(() => this.$api('Admin.VideoAnalysis.Delete', {id: row.id}, true))
                    .then(() => {
                        this.$message.success('已删除');
                        this.load();
                    })
                    .catch(() => {});
            }
        }
    };
</script>
